export default "__VITE_ASSET__CVi8_Ecj__"